import { getDicts } from '@/api/system/dict/data'
import { getDicts as getDictsH5 } from '@/api/h5/login';
import useDictStore from '@/store/modules/dict'
/**
 * 获取字典数据
 */
export function useDict (...args) {
  const res = ref({});
  return (() => {
    args.forEach((dictType, index) => {
      res.value[dictType] = [];
      const dicts = useDictStore().getDict(dictType);
      if (dicts) {
        res.value[dictType] = dicts;
      } else {
                   
        if (location.href.indexOf('/h5') > -1) {
          getDictsH5(dictType).then(resp => {
            res.value[dictType] = resp.data.map(p => ({ label: p.dictLabel, value: p.dictValue, elTagType: p.listClass, elTagClass: p.cssClass }))
            useDictStore().setDict(dictType, res.value[dictType]);
          })
        } else {
          getDicts(dictType).then(resp => {
            res.value[dictType] = resp.data.map(p => ({ label: p.dictLabel, value: p.dictValue, elTagType: p.listClass, elTagClass: p.cssClass }))
            useDictStore().setDict(dictType, res.value[dictType]);
          })
        }
      }
    })
    return toRefs(res.value);
  })()
}

export function RenderDictLabel(value,list = []){
    if(!list.length) return ''
    const obj = list.find(item => item.value == value)
    if(obj){
       return obj.label
    }
    return ''
}